export default "__VITE_ASSET__BDwku9Sa__"